import { useMemo } from "react";
import { Canvas } from "@react-three/fiber";
import Experience from "./experience/Experience";
import { Intro } from "./ui/Intro";
import { HUD } from "./ui/HUD";
import { UnlockOverlay } from "./ui/UnlockOverlay";
import { BoostOverlay } from "./ui/BoostOverlay";
import { HeapNav } from "./ui/HeapNav";
import { InputBridge } from "./ui/InputBridge";
import { CAMERA } from "./config/game";
import { threeColors } from "./theme/tokens";
import { useGameStore } from "./state/useGameStore";

function GameCanvas() {
  const coarsePointer = useGameStore((s) => s.coarsePointer);

  const dpr = useMemo(() => {
    if (typeof window === "undefined") return [1, 1.5];
    const small = window.matchMedia("(max-width: 768px)").matches;
    if (coarsePointer || small) return [1, 1];
    return [1, 1.5];
  }, [coarsePointer]);

  return (
    <Canvas
      className="stage"
      dpr={dpr}
      gl={{
        antialias: !coarsePointer,
        powerPreference: "high-performance",
        alpha: false,
      }}
      shadows={!coarsePointer}
      camera={{
        position: [CAMERA.intro.x, CAMERA.intro.y, CAMERA.intro.z],
        fov: 42,
        near: 0.1,
        far: 200,
      }}
      onCreated={({ gl }) => {
        gl.setClearColor(threeColors.ink, 1);
      }}
    >
      <Experience />
    </Canvas>
  );
}

export default function App() {
  return (
    <div className="app">
      <a className="skip-link" href="#game-stage">
        Skip to game
      </a>

      <div id="game-stage" className="stage-wrap">
        <GameCanvas />
      </div>

      <div className="ui-layer">
        <Intro />
        <HUD />
        <UnlockOverlay />
        <BoostOverlay />
        <HeapNav />
      </div>

      <InputBridge />
    </div>
  );
}
